import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatUrl } from '@ifeng-fe/public_method';
import Chip from 'Chip';
import styles from './index.css';
import { classNames } from '../../../utils/classnames';
import { rel as relText } from '../../../utils/rel';

class NavList extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    listView(list = []) {
        return list.map((item, index) => {
            return (
                <a key={index} href={formatUrl(item.url)} target="_blank" rel={relText}>
                    {item.title}
                </a>
            );
        });
    }
    render() {
        return <div className={styles.nav}>{this.listView(this.props.content)}</div>;
    }
}

class Nav extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { channel, topnav } = this.props.content;

        return (
            <div className={classNames(styles.box, 'clearfix')}>
                <a className={styles.logo} href={formatUrl(channel[0].domain)} target="_blank" rel={relText}>
                    <img src={formatUrl(channel[0].logo)} alt={channel[0].title} />
                </a>
                <Chip id="45006" type="struct" title="导航" groupName="导航" content={topnav}>
                    <NavList />
                </Chip>
            </div>
        );
    }
}

export default Nav;
